import { ArrowRight } from "lucide-react";

const goto = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="/images/exterior.jpg"
          alt="Villa Porcelaine Keszthely homlokzat"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0A0A0A]/55" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/85 via-[#0A0A0A]/55 to-[#0A0A0A]/35" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#000000]/65 via-[#000000]/25 to-transparent" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 min-h-[100vh] flex flex-col justify-end pb-20 pt-32">
        <div className="max-w-3xl">
          <p className="eyebrow text-[#E8D5B0] mb-6 [text-shadow:0_2px_6px_rgba(0,0,0,0.7)]" data-testid="hero-eyebrow">
            Coworking · Tárgyaló · Iroda Keszthelyen
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif-display text-white text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] tracking-tight [text-shadow:0_3px_20px_rgba(0,0,0,0.75)]"
          >
            Dolgozz egy<br />
            <span className="italic font-light">villában</span>, ne csak<br />
            egy irodában.
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-xl text-white text-base md:text-lg leading-relaxed [text-shadow:0_2px_10px_rgba(0,0,0,0.75)]"
          >
            A Villa Porcelaine exkluzív környezetében – modern bútorok, korlátlan
            kávé és tetőtéri természetes fény. Foglalj asztalt órára, napra vagy
            hónapra néhány kattintással.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <button
              data-testid="hero-cta-book"
              onClick={() => goto("foglalas")}
              className="inline-flex items-center justify-center gap-3 px-8 py-4 text-[12px] tracking-[0.25em] uppercase font-semibold bg-[#FAF9F6] text-[#1A1A1A] hover:bg-[#C5A059] hover:text-white transition-all duration-300 shadow-[0_4px_20px_rgba(0,0,0,0.25)]"
            >
              Foglalás indítása <ArrowRight className="w-4 h-4" />
            </button>
            <button
              data-testid="hero-cta-services"
              onClick={() => goto("szolgaltatasok")}
              className="inline-flex items-center justify-center gap-3 px-8 py-4 text-[12px] tracking-[0.25em] uppercase font-semibold border-2 border-white bg-white/10 backdrop-blur-sm text-white hover:bg-white hover:text-[#1A1A1A] transition-all duration-300"
            >
              Árak megtekintése
            </button>
          </div>
        </div>
      </div>

      {/* Bottom address strip */}
      <div className="absolute bottom-0 left-0 right-0 z-10 hidden md:block">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-8">
          <div className="flex items-end justify-between text-white text-[11px] tracking-[0.25em] uppercase [text-shadow:0_2px_4px_rgba(0,0,0,0.7)]">
            <span>8360 Keszthely · Erzsébet királyné útja 38.</span>
            <span>Est. Villa Porcelaine</span>
          </div>
        </div>
      </div>
    </section>
  );
}
